import styled from '@emotion/styled';

const Wrapper = styled.section`
  margin-top: ${({ theme }) => theme.spacing[50]};
`;

const Head = styled.div`
  display: flex;
  align-items: start;
  gap: ${({ theme }) => theme.spacing[20]};
  margin-bottom: ${({ theme }) => theme.spacing[30]};
  color: ${({ theme }) => theme.colors.neutral.grey160};
  fill: currentcolor;
`;

const IconSlot = styled.span`
  flex: 0 0 auto;
  display: inline-flex;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const Description = styled.p`
  margin: 0;
  font-weight: bold;
  font-size: 0.875rem;
  line-height: 1.5;
`;

export { Wrapper, Head, IconSlot, Description };
